import { post } from '~/plugins/nikan-api'
import Endpoints from '@nikan/endpoints'
import {convertDateToFromNow,convertDate} from '~/plugins/nikan-mixins'
import _ from "lodash";

const Keys = {
    ADD_NOTIFICATION: 'add_notification',
    ADD_NOTIFICATIONS: 'add_notifications',
    ADD_Users: 'add_users',
    UPDATE_NOTIFICATIONToSeen: 'update_notificationToSeen',
    REPLACE_NOTIFICATION: 'replace_notification',
    CLEAR: 'clear'
}

export const state = {
    notifications: [],
    users: []
}
export const mutations = {
    [Keys.ADD_NOTIFICATION](state, notification) {
        if (typeof notification == 'object') {
            state.notifications.push(notification)
        }
    },
    [Keys.ADD_NOTIFICATIONS](state, notifications) {
        if (Array.isArray(notifications)) {
            state.notifications = notifications.concat(state.notifications)
        }
    },
    [Keys.ADD_Users](state, users) {
        if (Array.isArray(users)) {
            state.users = users
        }

    },
    [Keys.UPDATE_NOTIFICATIONToSeen](state, notificationId) {
        state.notifications[state.notifications.findIndex(x => x.id == notificationId)].isSeen = true

    },
    [Keys.REPLACE_NOTIFICATION](state, notifications) {
        if (!notifications || !notifications.length) {
            return
        }
        state.notifications = notifications
    },


    [Keys.CLEAR](state) {
        state.notifications = []
    }
}
export const actions = {
    async refresh({dispatch, commit, state}) {
        let notifications = await post(Endpoints.getUrl('notification.get'), {"lastCount": 10}, null, {preventConcurrent: false})
        if (notifications.success)
            dispatch('addNotifications', notifications.data.items)
    },
    makeNotificationSeen({dispatch, commit, state}, notificationIds) {
        if (notificationIds && notificationIds.length) {
            notificationIds.forEach(y => {
                commit(Keys.UPDATE_NOTIFICATIONToSeen, y)
            })
            return post(Endpoints.getUrl('notification.seen'), {notificationIds: notificationIds}, null, {preventConcurrent: false})
        }
    },
    addNotifications({dispatch, commit, state}, rowNotifications) {
        const icon = (part) => {
            switch (part) {
                case 'ReceiptHawala ':
                    return "fa-file"
                case 'Factor':
                    return "fa-file"
                case 'Chat':
                    return "fa-message"
                case 4:
                    return "fa-message"
                default:
                    return ""
            }
        }
        if (Array.isArray(rowNotifications)) {
            let temp = rowNotifications.map(x => ({
                ...x,
                icon: icon(x.part),
                fromNow: convertDateToFromNow(x.date),
                faDate: convertDate(x.date),
                senderUser: state.users.find(y => y.id == x.senderUserId)
            })).sort((a, b) => {
                return new Date(b.date).getTime() - new Date(a.date).getTime();
            })
            commit(Keys.ADD_NOTIFICATIONS, temp)

        }


    },
    async getUsersForNotification({dispatch, commit, state}) {

        let usersWithDetails = await post(Endpoints.getUrl('user.list'), {}, null, {preventConcurrent: false})

        if (usersWithDetails.success) {
            commit(Keys.ADD_Users, usersWithDetails.data.items)
            return usersWithDetails.data.items
        }
    },

    async sendNotification({}, parentThis, senderId, receiverId) {
        const validateInputs = () => {
            let errors = []

            if (parentThis.localData.note.required && _.isEmpty(parentThis.localData.note.value))
                errors.push({
                    key: '',
                    error: parentThis.$t('msg.required', [parentThis.localData.note.name])
                })


            parentThis.validationToast(errors)
            return errors.length === 0
        }


        let url = Endpoints.getUrl('notification.create')


        let data = {
            "notification": {
                "senderUserId": parentThis.userDetail.id,
                "reciverUserId": parentThis.settings.receiverUser.id,
                "description": parentThis.localData.note.value,
                // "tag":'5dd1c9af-2b33-ed11-8c6d-20689d8178e6',
                "part": 'Chat'  //1 reciptHavale  2factor  3chat 4info
            }
        }

        if (validateInputs()) {
            let wait = parentThis.$wait(parentThis.grandParent)
            await post(url, data)
                .then((response) => {
                    wait.end()
                    parentThis.$toast(parentThis.$t('notification.create-successful'), {type: 'success'})
                    parentThis.resolve(response)
                })
                .catch(() => {
                    wait.end()
                    // this.$toast(this.$t('note.modify-fail'))
                })
        }
    },


    addNotification({dispatch, commit, state}, notification) {
        dispatch('addNotifications', [notification])
    },
    clear({commit}) {
        commit(Keys.CLEAR)
    }
}
export const getters = {
    all: state => {
        return state.notifications
    },
    hasUnseen: state => {
        return state.notifications.some(x => !x.isSeen)
    },
    unseen: state => {
        return state.notifications.filter(x => !x.isSeen)
    },
    getById: state => id => {
        return state.notifications.find(x => x.id === id)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
